import React from 'react';

export default function CheckProgress({ passed = 0, issues = 0, pending = 7 }) {
  const total = passed + issues + pending;
  const completed = passed + issues;
  const completionPercentage = total > 0 ? Math.round((completed / total) * 100) : 0;

  // SVG Circular progress math (Radius 50, Circumference ~314.16)
  const radius = 50;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (completionPercentage / 100) * circumference;

  return (
    <div className="w-[280px] bg-white rounded-2xl p-6 border border-gray-100 shadow-sm font-sans select-none">
      {/* Title */}
      <h3 className="text-gray-900 font-bold text-base mb-6 text-left">
        Check Progress
      </h3>

      {/* Progress Circle Container */}
      <div className="flex flex-col items-center justify-center mb-6">
        <div className="relative w-40 h-40 flex items-center justify-center">
          {/* SVG Ring Background & Progress */}
          <svg className="w-full h-full transform -rotate-90" viewBox="0 0 120 120">
            {/* Background Track Circle */}
            <circle
              cx="60"
              cy="60"
              r={radius}
              className="text-gray-100"
              strokeWidth="10"
              stroke="currentColor"
              fill="transparent"
            />
            {/* Dynamic Progress Circle */}
            <circle
              cx="60"
              cy="60"
              r={radius}
              className="text-blue-600 transition-all duration-500 ease-out"
              strokeWidth="10"
              strokeDasharray={circumference}
              strokeDashoffset={strokeDashoffset}
              strokeLinecap="round"
              stroke="currentColor"
              fill="transparent"
            />
          </svg>

          {/* Inner Text Center */}
          <div className="absolute flex flex-col items-center justify-center text-center">
            <span className="text-2xl font-extrabold text-slate-900 tracking-tight">
              {completed} / {total}
            </span>
            <span className="text-xs font-medium text-slate-400 mt-0.5">
              Completed
            </span>
          </div>
        </div>

        {/* Text Percentage Display */}
        <span className="text-sm font-bold text-slate-900 mt-4">
          {completionPercentage}% complete
        </span>
      </div>

      {/* Legend Metrics List */}
      <div className="space-y-4 pt-2 border-t border-gray-50">
        {/* Passed Status */}
        <div className="flex items-center justify-between text-sm">
          <div className="flex items-center space-x-3">
            <span className="w-3 h-3 rounded-full bg-emerald-600 inline-block" />
            <span className="font-semibold text-slate-700">Passed</span>
          </div>
          <span className="font-bold text-slate-800">{passed}</span>
        </div>

        {/* Issues Status */}
        <div className="flex items-center justify-between text-sm">
          <div className="flex items-center space-x-3">
            <span className="w-3 h-3 rounded-full bg-red-500 inline-block" />
            <span className="font-semibold text-slate-700">Issues</span>
          </div>
          <span className="font-bold text-slate-800">{issues}</span>
        </div>

        {/* Pending Status */}
        <div className="flex items-center justify-between text-sm">
          <div className="flex items-center space-x-3">
            <span className="w-3 h-3 rounded-full bg-indigo-200 inline-block" />
            <span className="font-semibold text-slate-700">Pending</span>
          </div>
          <span className="font-bold text-slate-800">{pending}</span>
        </div>
      </div>
    </div>
  );
}
